import React, { useState, useEffect } from 'react';
import Layout from '../Layout/Layout';
import API_URL from '../../Config';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import '../../App.css';
import AudioPlayer from '../../admin/AudioPlayer';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

const AudioHomescreen = () => {
  const [categories, setCategories] = useState([]);
  const [audioBanners, setAudioBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filename, setFilename] = useState(null);
  const [audiotitle, setAudiotitle] = useState(null);
  const userid = sessionStorage.getItem("userId");

  // Fetch audio banners
  const fetchAudioBanners = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v2/getallaudiobanner`);
      setAudioBanners(response.data);
    } catch (error) {
      console.error('Error fetching audio banners:', error);
    }
  };

  // Fetch audio containers
  const fetchAudioContainer = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/v2/audioContainerDetails`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching audio container:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAudioBanners();
    fetchAudioContainer();
  }, []);

  const handleEdit = (id) => {
    localStorage.setItem('item', id);
    window.scrollTo(0, 0);
  };

  const handleCategoryAction = (filename, audioTitle) => {
    setAudiotitle(audioTitle);
    setFilename(filename);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const audioSrc = `${API_URL}/api/v2/${filename}/file`;

  return (
    <Layout>
    <div className="banner-container mt-3">
      {audioBanners.length > 0 ? (
        <div className="w-screen px-0 mx-auto">
          <Splide
            options={{
              type: 'loop',
              perPage: 1,
              focus: 'center',
              autoplay: true,
              interval: 4000,
              pauseOnHover: false,
              pauseOnFocus: false,
              speed: 800,
              gap: '6rem',
              padding: '10vw',
              arrows: false,
              pagination: true,
              lazyLoad: 'nearby',
              breakpoints: {
                1024: {
                  padding: '10vw',
                },
                768: {
                  padding: '5vw',
                },
              },
            }}
            className="main-banner-splide"
          >
            {audioBanners.map((banner, index) => (
              <SplideSlide key={index}>
                <Link
                  to={userid ? `/MusicPage` : "/UserLogin"}
                  onClick={() => handleEdit(banner.movienameID)}
                >
                  <div className="w-full px-0 flex justify-center items-center">
                    <img
                      src={`${API_URL}/api/v2/getimage/banner/${banner.movienameID}`}
                      alt={`Banner ${index}`}
                      className="banner-image"
                      style={{
                        height: "500px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Link>
              </SplideSlide>
            ))}
          </Splide>
        </div>
      ) : (
        <div>No banners available</div>
      )}
    </div>
      {/* Category Sliders */}
      <div style={{marginTop:'80px'}}>
        {categories.length === 0 ? (
          <div className="banner-container">AudioContainer is empty</div>
        ) : (
          categories.map((category, index) =>
            category.audiolist?.length > 0 && (
              <div key={index}>
                <h2 className="custom-label" style={{ paddingLeft: '20px', fontSize: '30px', margin: '0px', marginTop: '20px' }}>
                  {category.category_name}
                </h2>
                <div className="row" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                  <CategorySlider
                    category={category}
                    API_URL={API_URL}
                    handleCategoryAction={handleCategoryAction}
                  />
                </div>
              </div>
            )
          )
        )}
      </div>

      {/* Audio Player */}
      {filename && <AudioPlayer audioSrc={audioSrc} audiotitle={audiotitle} />}
    </Layout>
  );
};

const CategorySlider = ({ category, API_URL, handleCategoryAction }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slidesToShow = 6;
  const totalSlides = category.audiolist.length;

  const goNext = () => {
    if (currentIndex < totalSlides - slidesToShow) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const goPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const triggerParentFunction = (filename, audioTitle) => {
    handleCategoryAction(filename, audioTitle);
  };

  return (
    <div className="slider-container">
      {/* LEFT overlay */}
      {totalSlides > slidesToShow && currentIndex > 0 && (
        <button
          className="side-nav left"
          onClick={goPrev}
          disabled={currentIndex === 0}
          aria-label="Previous"
        >
          <i className="bi bi-chevron-left"></i>
        </button>
      )}

      <div className="slider-track">
        <div
          className="slider-content"
          style={{
            transform: `translateX(-${currentIndex * (100 / slidesToShow)}%)`,
          }}
        >
          {category.audiolist.map((audio) => (
            <div
              key={audio.id}
              className="item"
              onClick={() =>
                triggerParentFunction(audio.audio_file_name, audio.audio_title)
              }
            >
              <img
                src={`${API_URL}/api/v2/image/${audio.id}`}
                alt={audio.audio_title}
              />
              <p className="title">{audio.audio_title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT overlay */}
      {totalSlides > slidesToShow && currentIndex < totalSlides - slidesToShow && (
        <button
          className="side-nav right"
          onClick={goNext}
          disabled={currentIndex >= totalSlides - slidesToShow}
          aria-label="Next"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      )}
    </div>
  );
};


export default AudioHomescreen;